export default [
  {
    path: '/catalog/sale',
    name: 'catalog-sale',
    component: () => import('../views/catalog/sale.vue')
  },
  {
    path: '/catalog',
    name: 'catalog-index',
    component: () => import('../views/catalog/index.vue')
  },
  {
    path: '/catalog/mysklad',
    name: 'catalog-mysklad',
    component: () => import('../views/catalog/mysklad.vue')
  },
   {
    path: '/catalog/invert',
    name: 'catalog-invert',
    component: () => import('../views/catalog/invert.vue')
  }


]
